module.exports = __webpack_public_path__ + "static/media/camping-devices.5241c078.jpg";